export const archivedProjectsColumns = [
    { accessor: 'id', Header: 'Project ID' },
    { accessor: 'name', Header: 'Project name' },
    { accessor: 'createdBy', Header: 'Created by' },
    { accessor: 'createdAt', Header: 'Created' },
    { id: 'actions', Header: 'Actions' },
];
